import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@Component({
  selector: 'wms-input-select',
  standalone: true,
  imports: [BsDropdownModule, CommonModule, FormsModule],
  templateUrl: './input-select.component.html',
  styleUrl: './input-select.component.less'
})
export class InputSelectComponent implements OnChanges{
  @Input() options: string[] = [];
  @Input() selectedValue:any =  '';
  @Input() titleVal?: string  = ''
  @Input() icon?: string  = ''
  @Input() propertyName!: any;
  @Output() valueChange = new EventEmitter<string>();

  lastEnteredValue: string = '';

  ngOnChanges(): void {
    if(this.selectedValue){
      this.lastEnteredValue = !this.options.includes(this.selectedValue) ? this.selectedValue : this.lastEnteredValue
    }
  }

  onInputChange(value: string) {
    this.handleValueChange(value)
  }

  handleValueChange(value: string){
    this.selectedValue = value;
    this.valueChange.emit(value);
  }
}
